<template>
    <div class="table-head head-fixed waiting-fixed">
        <div class="table-tr">
            <div class="table-th cell-length">{{ __('Patient') }}</div>
            <div v-if="showDaysTillEndOfSubscription" class="table-th cell-prescription">
                {{ __('Prescription will expire') }}
            </div>
            <div class="table-th cell-progress">
                <button :class="{ active: showProgressCells === 'weight' }" class="button-weight" type="button" @click="selectProgressCells('weight')">
                    {{ __('Weight') }}
                </button>
                <button :class="{ active: showProgressCells === 'waist' }" class="button-waist" type="button" @click="selectProgressCells('waist')">
                    {{ __('Waist circumference') }}
                </button>
            </div>
            <div class="table-th cell-weight">{{ __('Change') }}</div>
            <div class="table-th cell-therapist">{{ __('Assigned dietitian') }}</div>
        </div>
    </div>
</template>

<script>
import TableHeader from '@components/PatientsMatrix/TableHeader'
import TableHeaderProgressCellsMixin from '@components/PatientsMatrix/Mixins/TableHeaderProgressCellsMixin'

export default {
    extends: TableHeader,
    mixins: [TableHeaderProgressCellsMixin]
}
</script>
